<template>
<div class="chapter">
<div class="inner_page">
<p class="chap1">CONTENTS</p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/int">Introduction</a></p>
<p class="toc1"><a href="#/chapter01"><b>T<span class="small">HE</span> S<span class="small">CENE</span></b></a></p>
<p class="image1"><img alt="Images" src="images/line.jpg"/></p>
<p class="toca"><a href="#/chapter01#h1">The Nashville Food Truck Explosion and the Nashville Food Truck Association</a></p>
<p class="toc"><a href="#/chapter01#h2">The Big Food Truck Events</a></p>
<p class="toc"><a href="#/chapter01#h3">Wise Words for Prospective Food Truck Owners</a></p>
<p class="toc1"><span href="#/chapter02" title="Link target outside of Sample"><b>T<span class="small">HE</span> T<span class="small">RUCKS</span></b></span></p>
<p class="image1"><img alt="Images" src="images/line.jpg"/></p>
<p class="toca"><span href="#/chapter02#h1" title="Link target outside of Sample">Biscuit Love</span></p>
<p class="toc"><span href="#/chapter02#h2" title="Link target outside of Sample">Bradley’s Curbside Creamery</span></p>
<p class="toc"><span href="#/chapter02#h3" title="Link target outside of Sample">Confeastador</span></p>
<p class="toc"><span href="#/chapter02#h4" title="Link target outside of Sample">Crepe A Diem</span></p>
<p class="toc"><span href="#/chapter02#h5" title="Link target outside of Sample">DegThai</span></p>
<p class="toc"><span href="#/chapter02#h6" title="Link target outside of Sample">Delta Bound</span></p>
<p class="toc"><span href="#/chapter02#h7" title="Link target outside of Sample">Doughworks &amp; Loco Donuts</span></p>
<p class="toc"><span href="#/chapter02#h8" title="Link target outside of Sample">The Grilled Cheeserie</span></p>
<p class="toc"><span href="#/chapter02#h9" title="Link target outside of Sample">Hoss’ Loaded Burgers</span></p>
<p class="toc"><span href="#/chapter02#h10" title="Link target outside of Sample">The Mobile Chef</span></p>
<p class="toc"><span href="#/chapter02#h11" title="Link target outside of Sample">Moovers and Shakers</span></p>
<p class="toc"><span href="#/chapter02#h12" title="Link target outside of Sample">Music City Pie Company</span></p>
<p class="toc"><span href="#/chapter02#h13" title="Link target outside of Sample">Retro Sno</span></p>
<p class="toc"><span href="#/chapter02#h14" title="Link target outside of Sample">Riffs Fine Street Food</span></p>
<p class="toc"><span href="#/chapter02#h15" title="Link target outside of Sample">The Rolling Feast</span></p>
<p class="toc"><span href="#/chapter02#h16" title="Link target outside of Sample">Slow Hand Coffee Company</span></p>
<p class="toc"><span href="#/chapter02#h17" title="Link target outside of Sample">Smoke Et Al</span></p>
<p class="toc"><span href="#/chapter02#h18" title="Link target outside of Sample">Sum Yum Yum</span></p>
<p class="toc"><span href="#/chapter02#h19" title="Link target outside of Sample">Two Guys In a Lunchbox</span></p>
<p class="toc"><span href="#/chapter02#h20" title="Link target outside of Sample">The Waffle Boss</span></p>
<p class="toc"><span href="#/chapter02#h21" title="Link target outside of Sample">Yayo’s OMG</span></p>
<p class="toc1"><span href="#/chapter03" title="Link target outside of Sample"><b>T<span class="small">HE</span> N<span class="small">EWBIES</span></b></span></p>
<p class="image1"><img alt="Images" src="images/line.jpg"/></p>
<p class="toca"><span href="#/chapter03#h1" title="Link target outside of Sample">Bao Down</span></p>
<p class="toc"><span href="#/chapter03#h2" title="Link target outside of Sample">Bare Naked Bagel</span></p>
<p class="toc1a"><span href="#/final" title="Link target outside of Sample">Final Thoughts</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?d21018fe